import React from 'react'
import Personal from './Personal'
import Tagline from './Tagline'
import Contact from './Contact'
import About from './About'
import Availability from './Availability'
import { Errors } from '../../../../partials/Partials'

function PersonalData({errors, activBox}) {
    
  return (
    <div id="personal-data" className="section">
        <Errors errors={errors} />
        <Personal />
        <Tagline />
        <Contact activBox={activBox}/>
        <About />
        <Availability />
    </div>
  )
}

export default PersonalData